import { connect } from "react-redux";
import { Action, ThunkDispatch } from "@reduxjs/toolkit";

import {
  getLoggedInUserByEmail,
  getRefreshToken,
  getSAML,
  getUserByClaims,
  logoutPortalApp,
  resendMfaCode,
  sendMfaCode,
  verifyMfaCode,
} from "../../actions/UserAction";
import { ApplicationState } from "../../redux/ApplicationState";
import { getConfigs } from "../../actions/AppConfigs";
import { RefreshTokenPayload, UserMfaInfo } from "../../models/User";
import { resetStates } from "../../actions/Common";
import AppContent from "../components/AppContent";
import { UserByClaimsActionDispatchTypes } from "../../constants/User";
import { getFeatureAccessData, getMasterRole } from "../../actions/Master";

const mapStateToProps = ({
  appConfigsState,
  loggedInUserState,
  userSendMfaInfoState,
  userVerifyMfaInfoState,
  userByClaimsState,
  registerUserState,
  masterRoleState,
  masterFeatureAccessState,
  samlResponseState,
  userLogoutState,
  refreshTokenResponseState
}: ApplicationState) => ({
  config: appConfigsState.response,
  loggedInUser: loggedInUserState.response,
  loggedInUserFlow: loggedInUserState.flow,
  userSendMfaInfoState: userSendMfaInfoState.response,
  userSendMfaInfoErrorState: userSendMfaInfoState.error,
  userVerifyMfaInfoState: userVerifyMfaInfoState.response,
  userByClaimsState: userByClaimsState.response,
  registerUserState: registerUserState.response,
  masterRoleState: masterRoleState.response,
  masterFeatureAccessState: masterFeatureAccessState.response,
  samlResponseState: getSamlResponse(samlResponseState),
  userLogoutState: userLogoutState.response,
  refreshTokenResponseState: getRefreshTokenResponse(refreshTokenResponseState)
});

const getSamlResponse = (samlResponseState: any) => {
  return samlResponseState.response
}

const getRefreshTokenResponse = (refreshTokenResponseState: any) => {
  return refreshTokenResponseState.response
}

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, Action<any>>
) => {
  return {
    getLoggedInUserByEmail: (userEmail: string) => {
      dispatch(getLoggedInUserByEmail(userEmail, 0));
    },
    getConfig: () => {
      dispatch(getConfigs());
    },
    sendMfaCode: (payload: UserMfaInfo) => {
      dispatch(sendMfaCode(payload));
    },
    resendMfaCode: (payload: UserMfaInfo) => {
      dispatch(resendMfaCode(payload));
    },
    verifyMfaCode: (payload: UserMfaInfo) => {
      dispatch(verifyMfaCode(payload));
    },
    resetStates: (actionType: string) => {
      dispatch(resetStates(actionType));
    },
    getUserByClaims: (headers: any) => {
      dispatch(getUserByClaims(headers));
    },
    resetUserByClaims: () => {
      dispatch({
        type: UserByClaimsActionDispatchTypes.GET_USER_BY_CLAIMS_RESET,
      });
    },
    getFeatureAccessData: () => {
      dispatch(getFeatureAccessData());
    },
    getMasterRole: () => {
      dispatch(getMasterRole());
    },
    getSAML: (payload: any) => {
      dispatch(getSAML(payload));
    },
    logoutPortalApp: () => { 
      dispatch(logoutPortalApp());
    },
    getRefreshToken: (payload: RefreshTokenPayload) => {
      dispatch(getRefreshToken(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppContent);
